import { render, staticRenderFns } from "./PromotionPreviewLabelsBar.vue?vue&type=template&id=97162dae&scoped=true"
import script from "./PromotionPreviewLabelsBar.vue?vue&type=script&lang=js"
export * from "./PromotionPreviewLabelsBar.vue?vue&type=script&lang=js"
import style0 from "./PromotionPreviewLabelsBar.vue?vue&type=style&index=0&id=97162dae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97162dae",
  null
  
)

export default component.exports